import { Navigate, useLocation } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import './assets/pico_main.css';
import PicoUtils from './lib/PicoUtils';
import PicoCategory from './PicoCategory';
import PicoContent from './PicoContent';
import PicoIndex from './PicoIndex';
import PicoMenu from './PicoMenu';

interface Props {
    lang: MultiLang;
    name: string;
}

const Pico = (props: Props) => {
    const { lang, name } = props;
    const { pathname, search } = useLocation();
    // Content pages carry relative links and images, so the module root always
    // keeps its trailing slash for the browser to resolve them against.
    if (pathname === `/${name}`) {
        return <Navigate to={`/${name}/${search}`} replace />;
    }
    const path = pathname.replace(`/${name}/`, '');
    if (path === '' || path === 'index.php') {
        const params = new URLSearchParams(search);
        const paramCatId = params.get('cat_id');
        if (paramCatId?.match(/^\d+$/)) {
            return <PicoCategory lang={lang} name={name} catId={parseInt(paramCatId, 10)} />;
        }
        const paramContentId = params.get('content_id');
        if (paramContentId?.match(/^\d+$/)) {
            return <PicoContent lang={lang} name={name} contentId={parseInt(paramContentId, 10)} />;
        }
        if (params.get('page') === 'menu') {
            return <PicoMenu lang={lang} name={name} />;
        }
        return <PicoIndex lang={lang} name={name} />;
    }
    const category = PicoUtils.getCategoryByPath(name, path);
    if (category !== null) {
        return <PicoCategory lang={lang} name={name} catId={category.id} />;
    }
    const content = PicoUtils.getContentByPath(name, path);
    if (content !== null) {
        return <PicoContent lang={lang} name={name} contentId={content.id} />;
    }
    return <PageNotFound lang={lang} />;
};

export default Pico;
